import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/sagivbengiat/cloned_projects/react-elastic-carousel/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import Carousel from 'react-elastic-carousel';
import Item from '../components/SimpleItem';
import breakPoints from '../components/breakPoints';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "onresize"
    }}>{`onResize`}</h1>
    <h4 {...{
      "id": "you-can-listen-to-the-onresize-event-of-the-carousel-this-will-get-invoked-on-each-resize-event-of-the-root-element-and-will-return-the-current-breakpoint-object-being-used"
    }}>{`You can listen to the `}<inlineCode parentName="h4">{`onResize`}</inlineCode>{` event of the `}<inlineCode parentName="h4">{`Carousel`}</inlineCode>{`, this will get invoked on each `}<inlineCode parentName="h4">{`resize`}</inlineCode>{` event of the root element and will return the current `}<inlineCode parentName="h4">{`breakPoint`}</inlineCode>{` object being used:`}</h4>
    <pre><code parentName="pre" {...{}}>{`(currentBreakPoint) => {/*...*/}
`}</code></pre>
    <Playground __position={0} __code={'<Carousel\n  breakPoints={breakPoints}\n  onResize={currentBreakPoint => console.log(currentBreakPoint)}\n>\n  <Item>1</Item>\n  <Item>2</Item>\n  <Item>3</Item>\n  <Item>4</Item>\n  <Item>5</Item>\n  <Item>6</Item>\n</Carousel>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Carousel,
      Item,
      breakPoints,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Carousel breakPoints={breakPoints} onResize={currentBreakPoint => console.log(currentBreakPoint)} mdxType="Carousel">
    <Item mdxType="Item">1</Item>
    <Item mdxType="Item">2</Item>
    <Item mdxType="Item">3</Item>
    <Item mdxType="Item">4</Item>
    <Item mdxType="Item">5</Item>
    <Item mdxType="Item">6</Item>
    </Carousel>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      